import { useToast } from '@repo/design-system/index'
import { ActivityComponentType } from '@stackflow/react'
import { useState } from 'react'
import { enterConversationAi } from '../../../modules/apis/student/conversation'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useReturnFullUrl from '../../../modules/hooks/webview/common/useReturnFullUrl'
import { n_material_list, n_upcoming_lessons } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { BottomFixedSection, SelectMaterialProvider } from '../../../pages/[lang]/portal/lessons/materials/[lessonId]'
import { useAITutorStack } from '../../../pages/[lang]/webview/ai-tutor'
import { SearchResultListSection } from '../../new-portal/lessons/materials/SelectMaterialBody'
import SelectMaterialSearchSection from '../../new-portal/lessons/materials/SelectMaterialSearchSection'
import WebviewStackContainer from '../common/WebviewStackContainer'

interface IMaterialSearch {
  params: {
    threadId: string
    materialId: string | null
  }
}

const AITutorDiscussionMaterialSearchActivity: ActivityComponentType = ({ params }: IMaterialSearch) => {
  const { useAITutorFlow } = useAITutorStack()
  const { push, pop } = useAITutorFlow()
  const router = useAppRouter({ stackPush: push, browserDetect: true })

  const { t } = useTranslation()
  const { toastError, toastSuccess } = useToast()
  const [webviewKeyword, setWebviewKeyword] = useState('')
  const [loading, setLoading] = useState(false)
  const getFullUrl = useReturnFullUrl()

  const onStartConversation = async (courseId) => {
    if (loading) return
    setLoading(true)
    await enterConversationAi({ courseId }, router, getFullUrl, true)
    setLoading(false)
  }

  // 교재 저장 버튼
  const handleClickSaveMaterial = async (lessonId, materialId) => {
    if (!materialId) {
      toastError(t(n_upcoming_lessons.edit_materials.tab_desc))
      return
    }
    onStartConversation(materialId)
  }

  return (
    <SelectMaterialProvider>
      <WebviewStackContainer onBack={pop} title={t(n_material_list.all.title_search)}>
        <div className="relative mt-[16px] h-full w-screen flex-1 flex flex-col">
          <SelectMaterialSearchSection setWebviewKeyword={setWebviewKeyword} isAITutor={true} />
          {webviewKeyword.length >= 1 ? (
            <div className="my-[20px] px-[16px]">
              <SearchResultListSection keywords={webviewKeyword} isAITutor={true} />
            </div>
          ) : (
            <div className="h-full"></div>
          )}
          {webviewKeyword.length >= 1 && (
            <BottomFixedSection
              handleClickSaveMaterialWebview={handleClickSaveMaterial}
              isAITutor={true}
              loading={loading}
            />
          )}
        </div>
      </WebviewStackContainer>
    </SelectMaterialProvider>
  )
}

export default AITutorDiscussionMaterialSearchActivity
